import i18n from 'i18n-js';

import { ImageUpload, LEVELS } from '@helpers';
import { waitForDocumentProcessingChain } from '@reducers/utils';
import { KEYS_TAGS } from '@components/imageHandling/common';
import { IMAGE_UPLOAD_FOOTER_TEXT, IMAGE_UPLOAD_HEADER_TEXT, IMAGE_UPLOAD_MAIN_TEXT } from '@v2/pages/common/constants/base.constants';

import { SEND_STATUS } from '@helpers';
import type { BuildAddNcFileConfigParams, NcFileListItem } from '@components/search/operations/components/StartJobPopup/types';

type UploadStartData = { name?: string | null };

// Tracks the upload under a temporary random id, then swaps in the real ncFileId once processing resolves.
export const buildAddNcFileConfig = ({ item, scale, font, setUploadingFiles, setSendingStorage }: BuildAddNcFileConfigParams) => [
  {
    name: `Add NC File`,
    noArrow: true,
    showHoverEffect: true,
    onClick: () => {
      ImageUpload({
        uploadStart: async (data: UploadStartData) => {
          const randomId = Math.round(Math.random() * 10000);
          setUploadingFiles((prev) => [
            ...prev,
            {
              ncFileName: data?.name,
              ncFileId: randomId,
            },
          ]);

          setSendingStorage((prev) => ({
            ...prev,
            [randomId]: SEND_STATUS.Uploading,
          }));

          try {
            const result = await waitForDocumentProcessingChain({
              fileName: data?.name,
              productionOperationId: item.productionOperationId,
            });

            setUploadingFiles((prev) => [
              ...prev.filter((i) => i.ncFileId !== randomId),
              {
                ncFileName: data?.name,
                ncFileId: result.correlationData.ncFileId,
              },
            ]);

            setSendingStorage((prev) => ({
              ...prev,
              [randomId]: false,
              [result.correlationData.ncFileId]: false,
            }));
          } catch (e) {
            setSendingStorage((prev) => ({
              ...prev,
              [randomId]: SEND_STATUS.UploadingError,
            }));
          }
        },
        addExistingSearchLevel: LEVELS.NCFiles,
        onSuccessAddingExisting: (ncFile: NcFileListItem) => setUploadingFiles((prev) => [...prev, { ncFileId: ncFile.ncFileId, ncFileName: ncFile.ncFileName }]),
        addingNcFile: true,
        noPhoto: true,
        documentType: 'NcFile',
        tags: [
          {
            scopeId: KEYS_TAGS.ProductionOperation,
            scopeReferenceId: String(item.productionOperationId),
          },
        ],
        headerText: IMAGE_UPLOAD_HEADER_TEXT.AddNcFile,
        footerText: IMAGE_UPLOAD_FOOTER_TEXT.AddNcFile,
        headerDescription: i18n.t('To Job {{operationNumber}}', { operationNumber: item.productionOperationNumber }),
        mainText: IMAGE_UPLOAD_MAIN_TEXT.NcFile,
        scale,
        font,
      });
    },
  },
];
